import React from "react";

export function ItemForm({ item, onChange, onSave, onCancel, gId, inp, knownManufacturers }) {
          const listId = 'gamintojai-list-' + (gId || 'new');
          return (
            <tr style={{background:'#fff8f6'}}>
              <td colSpan="12" style={{padding:'10px'}}>
                {/* Datalist gamintojams */}
                <datalist id={listId}>
                  {(knownManufacturers||[]).map(g => <option key={g} value={g}/>)}
                </datalist>
                <div style={{display:'grid',gridTemplateColumns:'2fr 1fr 70px 60px 90px 50px 80px 90px 1fr 90px 90px 80px',gap:6,alignItems:'end'}}>
                  <div>
                    <div style={{fontSize:10,color:'#6b7280',marginBottom:2}}>Pavadinimas *</div>
                    <input style={inp} value={item.name} onChange={e=>onChange('name',e.target.value)} placeholder="Pavadinimas" />
                  </div>
                  <div>
                    <div style={{fontSize:10,color:'#6b7280',marginBottom:2}}>Gamintojas</div>
                    <input style={inp} list={listId} value={item.gamintojas||''} onChange={e=>onChange('gamintojas',e.target.value)} placeholder="Gamintojas" autoComplete="off"/>
                  </div>
                  <div>
                    <div style={{fontSize:10,color:'#6b7280',marginBottom:2}}>Mato vnt.</div>
                    <select style={inp} value={item.unit} onChange={e=>onChange('unit',e.target.value)}>
                      <option value="vnt.">vnt.</option>
                      <option value="m.">m.</option>
                      <option value="kompl.">kompl.</option>
                    </select>
                  </div>
                  <div>
                    <div style={{fontSize:10,color:'#6b7280',marginBottom:2}}>Vnt.</div>
                    <input style={inp} type="number" step="1" min="0" value={item.qty} onChange={e=>onChange('qty',e.target.value)} placeholder="1" />
                  </div>
                  <div>
                    <div style={{fontSize:10,color:'#6b7280',marginBottom:2}}>Kaina be PVM (€)</div>
                    <input style={inp} type="number" step="0.01" value={item.priceEx} onChange={e=>onChange('priceEx',e.target.value)} placeholder="0.00" />
                  </div>
                  <div>
                    <div style={{fontSize:10,color:'#6b7280',marginBottom:2}}>PVM %</div>
                    <input style={inp} type="number" value={item.pvmPct||21} onChange={e=>onChange('pvmPct',e.target.value)} />
                  </div>
                  <div>
                    <div style={{fontSize:10,color:'#6b7280',marginBottom:2}}>PVM suma (€)</div>
                    <input style={{...inp,background:'#f9fafb'}} type="number" step="0.01" value={item.pvmAmt} onChange={e=>onChange('pvmAmt',e.target.value)} />
                  </div>
                  <div>
                    <div style={{fontSize:10,color:'#6b7280',marginBottom:2}}>Kaina su PVM (€)</div>
                    <input style={inp} type="number" step="0.01" value={item.priceInc} onChange={e=>onChange('priceInc',e.target.value)} placeholder="0.00" />
                  </div>
                  <div>
                    <div style={{fontSize:10,color:'#6b7280',marginBottom:2}}>Kainos tipas</div>
                    <select style={inp} value={item.priceType||'client'} onChange={e=>onChange('priceType',e.target.value)}>
                      <option value="client">Kliento kaina</option>
                      <option value="personal">Asmeninė kaina</option>
                    </select>
                  </div>
                  <div>
                    <div style={{fontSize:10,color:'#6b7280',marginBottom:2}}>Nuolaida % (pirkimo)</div>
                    <input style={inp} type="number" step="0.1" value={item.discount} onChange={e=>onChange('discount',e.target.value)} placeholder="0" />
                  </div>
                  <div>
                    <div style={{fontSize:10,color:'#6b7280',marginBottom:2}}>Asmeninė kaina (€)</div>
                    <input style={{...inp,background:'#f0fff4'}} type="number" step="0.01" value={item.personalPrice} onChange={e=>onChange('personalPrice',e.target.value)} placeholder="0.00" />
                  </div>
                  <div style={{display:'flex',gap:4,paddingTop:16}}>
                    <button onClick={onSave} style={{background:'#383853',color:'#fff',border:'none',borderRadius:5,padding:'4px 8px',fontSize:11,fontWeight:700,cursor:'pointer'}}>✓</button>
                    <button onClick={onCancel} style={{background:'#f3f4f6',border:'none',borderRadius:5,padding:'4px 8px',fontSize:11,cursor:'pointer'}}>✕</button>
                  </div>
                </div>
              </td>
            </tr>
          );
        }
